import React from "react";
import { useTranslation } from 'react-i18next';
import styles from '../../../components/project/project-item.module.scss';

const Cancelled = ({ style }) => {
    const { t } = useTranslation();
    return <div className={`box--white ${styles.projectItem}`} style={style}>
        <div className={`box--plain ${styles.tasksBox}`}>
            <h3 style={{ 'textAlign': 'start' }}>{t('Item is cancelled')}</h3>
            {/* <div className={`box--blue-light ${styles.task}`}>
                <div className={styles.taskContent}>
                    <span>{t("The order is shipped. The Delivery will take")} {time} {t("to reach")}</span>
                </div>
            </div> */}
        </div>
    </div>
}

export default Cancelled